import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a7d0212e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d0212e')) {
      api.createRecord('a7d0212e', component.options)
    } else {
      api.reload('a7d0212e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a7d0212e&", function () {
      api.rerender('a7d0212e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notifications/create/index.vue"
export default component.exports